// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f0c16c52","453":"065c434b","455":"3873807d","977":"60a2df34"}[chunkId] + ".chunk.js";
};